import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { listStaff } from '../api/staffApi';
export function useStaff() {
  const { isDemo, store, scopeKey } = useWorkspace();
  const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'staff', isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.employees.filter(e => e.store_id === store?.id)) : listStaff(signal), enabled: Boolean(store?.id), staleTime: 60_000 });
}
